import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import MenuIcon from "@mui/icons-material/Menu";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { Avatar, FormControl, InputLabel, ListItemIcon, Menu, MenuItem, Select } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import "./DashboardHome.css";
import axios from "axios";
import { baseUrl } from "../utils/constants";
import localizationStrings, { changeLanguage } from "../utils/localizations";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import PushToTalk from "../components/PushToTalk";
export const drawerWidthBig = "300px";

function DashboardHome(props) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [actions, setActions] = useState(null);
  const [reload, setReload] = useState({});
  const [unreadCount, setUnreadCount] = useState(0);
  const [startAt, setStartAt] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  const [showInfo1, setShowInfo1] = useState(false);
  const [drawerShown, setDrawerShown] = useState(
    trim(global.location.pathname, "/") === "dashboard-home" ||
      trim(global.location.pathname, "/") === "dashboard-home/tracking"
      ? false
      : true,
  );
  const drawerWidth = drawerShown ? drawerWidthBig : "75px";

  const [mobileOpen, setMobileOpen] = React.useState(false);
  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  const getUnreadCount = async () => {
    try {
      const res = await axios.get(baseUrl + "getUnreadCount");
      setUnreadCount(res.data.result);
    } catch (e) {
      console.warn(e);
    }
  };

  const checkRoleExists = (role_id) => {
    return ((JSON.parse(localStorage.getItem("user") || "{}") || {}).roles || []).indexOf(role_id) > -1;
  };

  const [__, ___, removeCookie] = useCookies(["jwt"]);

  const drawer = (
    <div
      dir={localizationStrings.getLanguage() === "ar" ? "rtl" : "ltr"}
      style={{
        display: "flex",
        flexDirection: "column",
        fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
        width: drawerWidth,
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{ display: { sm: "none", md: "block" } }}
        style={{ position: "absolute", top: 20, right: 20 }}
        onClick={() => setDrawerShown((r) => !r)}
      >
        <MenuOpenIcon style={{ fontSize: 30, transform: drawerShown ? "rotate(0deg)" : "rotate(180deg)" }} />
      </Box>
      <img
        src={require("./../assets/images/logo-irshad.png")}
        style={{
          width: parseInt(drawerWidth) / 2,
          marginTop: 20,
          marginBottom: 20,
          alignSelf: "center",
        }}
      />
      <div
        style={{
          width: drawerWidth,
          display: "flex",
          backgroundColor: "#f2f6f9",
          padding: "15px 20px",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "3px",
            borderRadius: "100px",
            width: "46px",
            height: "46px",
          }}
        >
          <Avatar
            src={require("./../assets/images/dummy-image.png")}
            style={{
              backgroundColor: "#f2f6f9",
              width: "40px",
              height: "40px",
            }}
          />
        </div>
        {drawerShown && (
          <div
            style={{
              marginLeft: "10px",
              marginRight: "10px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Typography fontStyle={{ fontSize: "14px", color: "#0008" }}>
              {JSON.parse(localStorage.getItem("user") || "{}").name}
            </Typography>
            {/* <Typography fontStyle={{ fontSize: '14px', color: '#0008' }}>
            {((JSON.parse(localStorage.getItem('user') || '{}').roles || []).indexOf(2) > -1).toString()}
          </Typography> */}
          </div>
        )}
      </div>
      <List>
        {checkRoleExists(3) && (
          <DrawerItem
            title={localizationStrings.OnlineTracking}
            icon={<OnlinePredictionIcon />}
            navigateUrl="tracking"
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )}
        {/* <DrawerItem
          title={localizationStrings.Dashboard}
          icon={<DashboardIcon />}
          navigateUrl='dashboard'
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          drawerShown={drawerShown}
        /> */}
        {checkRoleExists(1) && (
          <DrawerItem
            title={localizationStrings.Employees + " " + (unreadCount > 0 ? "(" + unreadCount + ")" : "")}
            icon={<SupervisorAccountIcon />}
            navigateUrl="employees"
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )}
        {checkRoleExists(1) && (
          <DrawerItem
            title={localizationStrings.EmployeesPresent}
            icon={<SupervisorAccountIcon />}
            navigateUrl="employees-present"
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )}
        {/* {checkRoleExists(2) && (
          <DrawerItem
            title={localizationStrings.EmployeesTrips}
            icon={<SupervisorAccountIcon />}
            navigateUrl="employees-trips"
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )} */}
        {checkRoleExists(2) && (
          <DrawerItem
            title={localizationStrings.NotStartedTrips || "Not Started Trips"}
            icon={<CancelPresentationIcon />}
            navigateUrl="not-started"
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )}
        {checkRoleExists(2) && (
          <DrawerItem
            title={localizationStrings.NotIrshadTrips || "Not Irshad Trips"}
            icon={<PersonOffIcon />}
            navigateUrl="not-irshad"
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )}
        {checkRoleExists(4) &&
          (JSON.parse(localStorage.getItem("user") || "{}").EST_id == "null" ||
            !JSON.parse(localStorage.getItem("user") || "{}").EST_id) && (
            <DrawerItem
              title={localizationStrings.CompanyLogin || "Company Login"}
              icon={<DomainAddIcon />}
              navigateUrl="company-login"
              mobileOpen={mobileOpen}
              handleDrawerToggle={handleDrawerToggle}
              drawerShown={drawerShown}
            />
          )}
        {checkRoleExists(5) && (
          <DrawerItem
            title={localizationStrings.TimeAttendance}
            icon={<CheckBoxIcon />}
            navigateUrl="time-attendance"
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )}
        {/* {checkRoleExists(1) && checkRoleExists(5) && (
          <DrawerItem
            title={localizationStrings.EmployeeAttendance}
            icon={<SupervisorAccountIcon />}
            navigateUrl='employees-attendance'
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )} */}
        {checkRoleExists(1) && (
          <DrawerItem
            title={localizationStrings.PushNotification}
            icon={<CircleNotificationsIcon />}
            navigateUrl="push-notifications"
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            drawerShown={drawerShown}
          />
        )}
      </List>
    </div>
  );
  const handleMenu = (event) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const logout = async () => {
    // removeCookie("jwt", { path: "/" });
    // removeCookie("EST_id", { path: "/" });

    // localStorage.setItem("user", null);
    await axios.get(baseUrl + "logout");
    setTimeout(() => {
      window.location.href = "/login";
    }, 1000);
  };

  useEffect(() => {
    const checkLoggedIn = async () => {
      try {
        const data = await axios.get(baseUrl + "checkLogin");
        if (!data.data.status) {
          logout();
        } else {
          localStorage.setItem("user", JSON.stringify(data.data.result));
          await new Promise((res) => setTimeout(res, 1000));
          setReload({});
          props.reload?.();
        }
      } catch (e) {
        console.warn(e);
      }
    };
    if (process.env.NODE_ENV !== "development") {
      checkLoggedIn();
    }
  }, [navigate]);

  function trim(s, c) {
    if (c === "]") c = "\\]";
    if (c === "^") c = "\\^";
    if (c === "\\") c = "\\\\";
    return s.replace(new RegExp("^[" + c + "]+|[" + c + "]+$", "g"), "");
  }

  useEffect(() => {
    getUnreadCount();

    const interval = setInterval(() => {
      getUnreadCount();
    }, 10000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div>
      <CssBaseline />

      <nav className={"drawer"}>
        <Box sx={{ display: { xs: "block", md: "none" } }} component="div">
          <Drawer
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{ paper: "drawerPaper", root: "drawer" }}
          >
            <div
              style={{
                alignItems: "flex-end",
                display: "flex",
                flexDirection: "column",
                marginRight: "5px",
                marginTop: "5px",
                position: "absolute",
                top: 0,
                right: 0,
              }}
            >
              <IconButton onClick={handleDrawerToggle} style={{}}>
                <CloseIcon />
              </IconButton>
            </div>
            {drawer}
          </Drawer>
        </Box>
        <Box sx={{ display: { xs: "none", md: "block" } }} component="div">
          <Drawer
            classes={{ paper: "drawerPaper", root: "drawer" }}
            variant="permanent"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            style={{ width: drawerWidth }}
          >
            <div style={theme.mixins.toolbar} />
            {drawer}
          </Drawer>
        </Box>
      </nav>
      <Box
        sx={{
          marginLeft: {
            xs: 0,
            md: theme.direction === "ltr" ? drawerWidth : "0px",
          },
          marginRight: {
            xs: 0,
            md: theme.direction === "ltr" ? "0px" : drawerWidth,
          },
        }}
        className="content"
      >
        <AppBar className="appBar" style={{ background: "#E8DABC", color: "#000" }}>
          <Toolbar>
            <Box sx={{ display: { xs: "none", md: "block" } }} component="div">
              <div style={{ width: drawerWidth }}></div>
            </Box>
            <Box sx={{ display: { xs: "block", md: "none" } }} component="div">
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                style={{
                  [localizationStrings.getLanguage() === "ar" ? "marginLeft" : "marginRight"]: theme.spacing(2),
                }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              {trim(global.location.pathname, "/") === "dashboard-home" ||
              trim(global.location.pathname, "/") === "dashboard-home/tracking"
                ? localizationStrings.OnlineTracking
                : trim(global.location.pathname, "/") === "dashboard-home/employees"
                  ? localizationStrings.Employees
                  : trim(global.location.pathname, "/") === "dashboard-home/employees-attendance"
                    ? localizationStrings.EmployeeAttendance
                    : trim(global.location.pathname, "/") === "dashboard-home/employees-trips"
                      ? localizationStrings.EmployeesTrips
                      : global.location.pathname.includes("employees-trips")
                        ? localizationStrings.EmployeesTrips
                        : trim(global.location.pathname, "/") === "dashboard-home/not-started"
                          ? localizationStrings.NotStartedTrips || "Not Started Trips"
                          : trim(global.location.pathname, "/") === "dashboard-home/not-irshad"
                            ? localizationStrings.NotIrshadTrips || "Not Irshad Trips"
                            : trim(global.location.pathname, "/") === "dashboard-home/time-attendance"
                              ? localizationStrings.TimeAttendance || "TimeAttendance"
                              : trim(global.location.pathname, "/") === "dashboard-home/company-login"
                                ? localizationStrings.CompanyLogin || "Company Login"
                                : trim(global.location.pathname, "/") === "dashboard-home/push-notifications"
                                  ? localizationStrings.PushNotification || "Push Notification"
                                  : trim(global.location.pathname, "/") === "dashboard-home/employees-present"
                                    ? localizationStrings.EmployeesPresent || "Employees Present"
                                    : trim(global.location.pathname, "/") === "dashboard-home/dashboard"
                                      ? localizationStrings.Dashboard
                                      : trim(global.location.pathname, "/").includes("attendance")
                                        ? localizationStrings.EmployeeAttendance
                                        : localizationStrings.EmployeeDetails}
            </Typography>
            <PushToTalk
              absolute={false}
              header={true}
              showHandle={false}
              setStartAtUp={setStartAt}
              reloadUp={setReload}
              setShowInfoUp={setShowInfo1}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={localizationStrings.getLanguage()}
                label="Language"
                style={{ color: "black" }}
                onChange={(lng) => {
                  changeLanguage(lng.target.value);
                  setReload({});
                }}
              >
                <MenuItem
                  style={{
                    fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
                  }}
                  value={"ar"}
                >
                  {localizationStrings.Arabic}
                </MenuItem>
                <MenuItem
                  style={{
                    fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
                  }}
                  value={"en"}
                >
                  {localizationStrings.English}
                </MenuItem>
              </Select>
              {actions}
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem
                  style={{
                    fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
                  }}
                  onClick={logout}
                >
                  {localizationStrings.Logout}
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
        <div style={theme.mixins.toolbar} />
        <Outlet context={{ handleDrawerToggle, setActions, reload }} />
      </Box>
      <PushToTalk
        onlyHandle={true}
        startAtUp={startAt}
        showInfoUp={showInfo || showInfo1}
        setShowInfoUp={(val) => {
          setShowInfo(val);
          setShowInfo1(val);
        }}
        guidance_id={showInfo ? "1" : null}
      />
    </div>
  );
}
// DashboardHome.propTypes = {
//   container: PropTypes.object,
// };
export default DashboardHome;

function DrawerItem({ title, navigateUrl, handleDrawerToggle, mobileOpen, icon, drawerShown }) {
  const navigate = useNavigate();
  return (
    <ListItem
      button
      onClick={() => {
        if (mobileOpen) handleDrawerToggle();
        navigate(navigateUrl);
      }}
    >
      <div
        style={
          drawerShown
            ? { marginLeft: "10px", justifyContent: "center", alignItems: "center", display: "flex" }
            : { height: 48, width: "100%", justifyContent: "center", alignItems: "center", display: "flex" }
        }
      >
        <ListItemIcon style={drawerShown ? {} : { minWidth: "unset" }}>{icon}</ListItemIcon>
      </div>
      {drawerShown ? (
        <ListItemText
          primaryTypographyProps={{
            fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
          }}
          primary={title}
          style={{
            textAlign: localizationStrings.getLanguage() === "ar" ? "right" : "left",
          }}
        />
      ) : null}
    </ListItem>
  );
}
